<!-- zoom banner 导师辅导banner-->
<template>
  <div class="mentor-zoom-banner">
    <div class="mentor-zoom-banner-con">
      <h1 v-if="appDetail.menteeResultTimeStr">辅导开始时间：{{appDetail.menteeResultTimeStr}} （{{appDetail.menteeZone | zoneTitleMap}}）</h1>
      <div>
        <div class="mentor-zoom-banner-item">
          <div>
            <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
            <span v-else>{{appDetail.module | appModuleTitleMap }}</span>
            上限时间：{{remainTime.maxTime}}mins</div>
          <div>已使用时间：{{remainTime.usedTime}}mins</div>
        </div>
        <div class="mentor-zoom-banner-item">
          <div>
            <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
            <span v-else>{{appDetail.module | appModuleTitleMap }}</span>
            剩余时间：{{(remainTime.remainTime>0)?remainTime.remainTime:0}}mins</div>
          <div>预计讨论时间：{{appDetail.predictTime}}mins</div>
        </div>
      </div>
      <template v-if="appDetail.menteeZoom && (appDetail.statu==='INCOMPLETE' || appDetail.statu==='TO_FEEDBACK')">
        <p class="copy-link">Zoom链接地址：{{appDetail.menteeZoom}}</p>
        <p style="color: #fff; margin-top: 0">Meeting ID：{{meetingId}}</p>
        <a :href="appDetail.menteeZoom"
           target="_blank">开启Zoom</a>
      </template>
    </div>
  </div>
</template>

<script>
// api
import { getAppRemainTime } from '@/api/appointment'
import { getZoomMeetingId } from '../../../api/appointment'
export default {
  name: 'app-coach-zoom-banner',
  props: ['appDetail', 'isPackageId'],
  components: {},
  data () {
    return {
      remainTime: {},
      meetingId: undefined
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
    if (this.appDetail && this.appDetail.zoomUrl && this.appDetail.zoomUrl.id && this.appDetail.zoomUrl.value) {
      getZoomMeetingId(this.appDetail.zoomUrl.id, this.appDetail.zoomUrl.value).then(res => {
        if (res.code === 0) {
          this.meetingId = res.data.model.meetingId
        }
      })
    }
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'jointId': appDetail.jointId,
        'module': appDetail.module,
        'appointmentType': appDetail.type
      }).then(res => {
        this.remainTime = res.data.model
      })
    }
  },
  watch: {
    appDetail (data) {
      this.getAppRemainTime()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
